<template>
  <div class="mult_text_question">    
    <div class="qes_txt" :style="{'color':surveyTheme.bodyColor}">
      <i class="qes_num" v-if="surveyTheme.openCode">{{data.showNum}}.</i>
      <div class="qes_name" v-html="data.qesName"></div>
    </div>
    <div class="answers">
      <textarea @blur="selectAnswer()" class="mult_text_input" v-model="showSelected"></textarea>
    </div>
  </div>
</template>
<script>

 export default {
   components: { 
    
  },
  props: ['data','currentPage','index'],
  watch: {  
    // 'data'(){
    //   console.log('单行文本题data值变了',this.data);
    //   if(this.data.showSelected){
    //     this.showSelected = this.data.showSelected;
    //     console.log('有值',this.showSelected);
    //   }else{
    //     console.log('没有值');
    //   }
    // }
  },
  data(){
    return {
      surveyTheme:{},                         //问卷主题
      showSelected:"",                        //已选答案ID       (前端回显用)
      selectData:{},                          //已选答案相关对象 (提交后台用)
    }
  },
  created(){
    this.data.qesName = this.data.qesName.replaceAll('\n','<br/>');
    this.showSelected = this.data.showSelected;
    this.surveyTheme = JSON.parse(sessionStorage.getItem("surveyTheme"));
    // console.log(this.surveyTheme);
    console.log('单行文本题data',this.data);
  },
  methods:{
    selectAnswer(){
      // console.log(this.showSelected);
      this.data.showSelected = this.showSelected;
      let obj = {};
      obj.ansName = this.showSelected;
      obj.qesId = this.data.qesId;
      obj.surveyId = this.data.surveyId;
      obj.qesType = this.data.qesType;
      obj.otherType = this.data.otherType;
      obj.groId = this.data.groId;
      obj.qesName = this.data.qesName;
      obj.qesNum = this.data.qesNum;
      obj.qesOrder = this.data.qesOrder;
      this.selectData.gIndex = this.currentPage - 1;
      this.selectData.qIndex = this.index;
      this.selectData.submitQesObj = obj;
      // console.log(this.selectData);
      this.$emit("sendAnswer",this.selectData);
    }
  }
}
</script>
<style lang="less" scoped>
  .mult_text_question{
    background-color: transparent;
    width: 100%;
    padding: 60px 40px;
    box-sizing: border-box;
    .qes_txt{
      margin-bottom: 40px;
      font-size: 36px;
      color: #333;
      line-height: 56px;
      display: flex;
      align-items: center;
      .qes_num{
        font-size: 34px;
        // line-height: 65px;
        margin-right: 10px;
      }
      .qes_name{
        font-size: 36px;
        display: inline;
        word-break: break-all;
      }
    }
    .answers{
      .mult_text_input{
        width: 100%;
        height: 264px;
        line-height: 40px;
        border: 2px solid #f3eded;
        border-radius: 12px;
        padding: 20px 28px;
        color: #333;
        box-sizing: border-box;
        font-size: 28px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/textQuestion/multiTextQuestion.vue